import { FC } from 'react';

export const OffLayoutArea: FC = () => null;
